import React, { useState } from 'react'
import { Box, Input, MenuItem, Select, makeStyles } from '@material-ui/core'
import { dayTriggerOption } from '../../../../../../options'

const useStyles = makeStyles(() => ({
  timingSelectContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '4px',
    paddingBottom: '2px',
    paddingLeft: '15px',
  },
  smallInput: {
    '& .MuiInputBase-input': {
      width: '40px',
      marginLeft: '10px',
      fontSize: '12px',
      color: '#7F8FA4',
      border: '1px solid #c4c4c4',
      height: '8px',
    },
  },
  timingSelect: {
    '& .MuiSelect-select': {
      height: '20px',
      marginLeft: '10px',
      fontSize: '12px',
      color: '#7F8FA4',
    },
  },
  timingMenuItem: {
    fontSize: '12px',
  },
  timingTypeLabel: {
    '& .MuiInputBase-input': {
      marginLeft: '10px',
      height: '20px',
      fontSize: '12px',
      width: '9rem',
    },
  },
}))

export const TimingSelect = ({
  timingTypeLabelText,
  timingType,
  setTimingType,
  timingValue,
  setTimingValue,
}) => {
  const {
    timingSelectContainer,
    smallInput,
    timingSelect,
    timingMenuItem,
    timingTypeLabel,
  } = useStyles()
  const [keysPressed, setKeysPressed] = useState([...timingValue])

  const handleTimingValueChange = newTimingValue => {
    if (newTimingValue < 0) {
      setTimingValue(0)
    } else {
      setTimingValue(newTimingValue)
    }
  }

  const timing = timingValue.toString()
  const validateInteger = timing.includes('.') || timing.includes(',')

  const handleKeyDown = e => {
    const { key } = e
    if (key === '.' || key === ',') e.preventDefault()
    if (!keysPressed.includes(key)) {
      setKeysPressed([...keysPressed, key])
    }
  }

  const handleKeyUp = e => {
    const { key } = e
    setKeysPressed(keysPressed.filter(pressedKey => pressedKey !== key))
  }

  return (
    <div className={timingSelectContainer}>
      <Box>Select timing:</Box>
      <Input
        type="number"
        className={smallInput}
        disableUnderline={true}
        value={timingValue > 0 ? Math.floor(timingValue) : timingValue}
        onKeyDown={handleKeyDown}
        onChange={({ target }) => {
          handleTimingValueChange(target['value'])
        }}
        onBlur={() => {
          if (timingValue === '') setTimingValue(0)
          if (validateInteger) setTimingValue(Math.floor(timingValue))
        }}
        onKeyUp={handleKeyUp}
      />
      <Select
        className={timingSelect}
        value={timingType}
        disableUnderline={true}
        onChange={({ target }) => setTimingType(target['value'])}
      >
        {dayTriggerOption.map(item => (
          <MenuItem key={item.label} value={item.value}>
            <div className={timingMenuItem}>{item.label}</div>
          </MenuItem>
        ))}
      </Select>
      <Input
        size="small"
        className={timingTypeLabel}
        disableUnderline={true}
        disabled={true}
        value={timingTypeLabelText}
      />
    </div>
  )
}
